import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class OpenMasterBuyDialogAction implements Action {
  constructor(
    public type: FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-master-buy-dialog/family-plan-master-buy-dialog.action.ts